import { Link } from 'react-router-dom';
import React from 'react';

const NoCoverageWidget = ({ link }) => {
  return (
    <div className={'no-coverage-widget'}>
      <h3>
        You do not have Vision Coverage. Do you want to explore the options?
      </h3>
      <span>
        <Link to={link}>Find Coverage Options</Link>
      </span>
    </div>
  );
};
export default NoCoverageWidget;
